import React, { useState } from 'react';
import { List, Plus, BookOpen } from 'lucide-react';
import CourseListTab from './CourseListTab';
import CreateCourseTab from './CreateCourseTab';
import EditCourseTab from './EditCourseTab';
import CurriculumBuilderTab from './CurriculumBuilderTab';
import './CourseManagement.css';

const CourseManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'list' | 'create' | 'edit' | 'curriculum'>('list');
  const [editCourseId, setEditCourseId] = useState<number | null>(null);

  const handleEditCourse = (courseId: number) => {
    setEditCourseId(courseId);
    setActiveTab('edit');
  };

  const handleCreateNew = () => {
    setEditCourseId(null);
    setActiveTab('create');
  };

  const handleBackToList = () => {
    setEditCourseId(null);
    setActiveTab('list');
  };

  return (
    <div className="trainer-coursemanagement-container">
      {/* Breadcrumb */}
      <div className="trainer-coursemanagement-breadcrumb">
        <span>Content Management</span>
        <span className="trainer-coursemanagement-separator">›</span>
        <span>Course Management</span>
      </div>

      {/* Header - Only show when not editing */}
      {activeTab !== 'edit' && (
        <>
          <div className="trainer-coursemanagement-header">
            <div className="trainer-coursemanagement-header-content">
              <h1>Course Management</h1>
              <p>Assemble content assets into structured courses and learning paths</p>
            </div>
            {activeTab === 'list' && (
              <button
                className="trainer-coursemanagement-create-btn"
                onClick={handleCreateNew}
              >
                <Plus size={18} />
                Create New Course
              </button>
            )}
          </div>

          {/* Tabs */}
          <div className="trainer-coursemanagement-tabs">
            <button
              className={`trainer-coursemanagement-tab ${activeTab === 'list' ? 'trainer-coursemanagement-tab--active' : ''}`}
              onClick={handleBackToList}
            >
              <List size={16} />
              Course List
            </button>
            <button
              className={`trainer-coursemanagement-tab ${activeTab === 'create' ? 'trainer-coursemanagement-tab--active' : ''}`}
              onClick={handleCreateNew}
            >
              <Plus size={16} />
              Create Course
            </button>
            <button
              className={`trainer-coursemanagement-tab ${activeTab === 'curriculum' ? 'trainer-coursemanagement-tab--active' : ''}`}
              onClick={() => setActiveTab('curriculum')}
            >
              <BookOpen size={16} />
              Curriculum Builder
            </button>
          </div>
        </>
      )}

      {/* Tab Content */}
      <div className="trainer-coursemanagement-content">
        {activeTab === 'list' && <CourseListTab onEditCourse={handleEditCourse} />}
        {activeTab === 'create' && <CreateCourseTab onBackToList={handleBackToList} />}
        {activeTab === 'edit' && editCourseId && (
          <EditCourseTab courseId={editCourseId} onBack={handleBackToList} />
        )}
        {activeTab === 'curriculum' && <CurriculumBuilderTab />}
      </div>
    </div>
  );
};

export default CourseManagement;